module.exports = __webpack_public_path__ + "img/pJkoW.280e6ecc.svg";